import React, {Component} from 'react';
import PropTypes from 'prop-types';
import StringFilter from "./StringFilter";
import DateFilter from "./DateFilter";
import NumberFilter from "./NumberFilter";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import Pager from "../controls/Pager";
import BackEnd from "../backend/BackEnd";
import './DataGrid.css';

const $ = window.jQuery;

class DataGrid extends Component {
    static propTypes = {
        dataSource: PropTypes.object.isRequired,
        gridId: PropTypes.string.isRequired,
        pageSize: PropTypes.number,
        allowReset: PropTypes.bool,
        allowReload: PropTypes.bool,
        allowXlsxExport: PropTypes.bool,
        children: PropTypes.node.isRequired
    };
    static defaultProps = {
        pageSize: 15,
        allowReset: true,
        allowReload: true,
        allowXlsxExport: true
    };
    state = {
        isLoading: false,
        filters: {},
        facetFilters: {},
        sorting: null,
        pageIndex: 0,
        items: [],
        totalCount: 0
    };

    async componentDidMount() {
        await this.fetchGridData();
    }

    render() {
        const columns = this.props.children.map(column => column.props);
        return (
            <div className="panel">
                <div className="panel-heading">
                    <span className="panel-title">&nbsp;</span>
                    <div className="panel-heading-controls">
                        <Pager pageSize={this.props.pageSize}
                               pageIndex={this.state.pageIndex}
                               totalCount={this.state.totalCount}
                               onChange={pageIndex => this.updatePageIndex(pageIndex)}/>
                        <span className="panel-heading-text">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        {
                            this.props.allowReset &&
                            <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip id="reset-filters-tooltip">
                                                    Сбросить все поисковые фильтры
                                                </Tooltip>}>
                                <button className="btn btn-xs btn-outline btn-outline-colorless"
                                        onClick={() => this.resetFilters()}>
                                    <i className="fa fa-eraser"/>
                                </button>
                            </OverlayTrigger>
                        }
                        {
                            this.props.allowReload &&
                            <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip id="reload-grid-data-tooltip">
                                                    Обновить записи в гриде
                                                </Tooltip>}>
                                <button className="btn btn-xs btn-outline btn-outline-colorless"
                                        onClick={() => this.reloadGridData()}>
                                    <i className="fa fa-refresh"/>
                                </button>
                            </OverlayTrigger>
                        }
                        {
                            this.props.allowXlsxExport &&
                            <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip id="export-to-xlsx-tooltip">
                                                    Экспорт в формат Excel 2007+
                                                </Tooltip>}>
                                <button className="btn btn-xs btn-outline btn-outline-colorless"
                                        onClick={() => this.exportToXlsx()}>
                                    <i className="fa fa-cloud-download" />
                                </button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
                <div className="panel-body">
                    <div style={{overflowX: 'scroll'}}>
                        <table className={`table table-striped ${this.state.isLoading ? 'form-loading' : ''}`}>
                            <thead>
                            <tr>
                                {columns.map((column, i) =>
                                    <th key={i} className={`datagrid-th ${this.getSortClass(column)}`}
                                        style={{minWidth: '200px'}}
                                        onClick={() => this.toggleSort(column)}>
                                        {column.caption}
                                    </th>
                                )}
                            </tr>
                            <tr>
                                {columns.map((column, i) => {
                                    if (column.type === 'string')
                                        return (
                                            <td key={i}>
                                                <StringFilter fieldName={column.fieldName}
                                                              filter={this.state.filters[column.fieldName] || {}}
                                                              onChange={filter => this.updateFilters(column.fieldName, filter)}/>
                                            </td>
                                        );

                                    if (column.type === 'date')
                                        return (
                                            <td key={i}>
                                                <DateFilter fieldName={column.fieldName}
                                                            filter={this.state.filters[column.fieldName]}
                                                            onChange={filter => this.updateFilters(column.fieldName, filter)}/>
                                            </td>
                                        );

                                    if (column.type === 'number')
                                        return (
                                            <td key={i}>
                                                <NumberFilter fieldName={column.fieldName}
                                                              filter={this.state.filters[column.fieldName] || {}}
                                                              onChange={filter => this.updateFilters(column.fieldName, filter)}/>
                                            </td>
                                        );

                                    return <td key={i}/>;
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.items.length
                                    ? this.state.items.map(item =>
                                        <tr key={item.id}>
                                            {columns.map((column, i) =>
                                                <td key={i}>{column.cell(item)}</td>
                                            )}
                                        </tr>
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={columns.length}>Записи отсутствуют</td>
                                        </tr>
                                    )
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    async updatePageIndex(pageIndex) {
        this.setState({pageIndex});
        await this.fetchGridData(pageIndex);
    }

    async fetchGridData(pageIndex = this.state.pageIndex, filtersHash = this.state.filters) {
        const {dataSource} = this.props;

        this.setState({isLoading: true});

        let filters = Object.keys(filtersHash).map(key => filtersHash[key]).filter(f => f);
        let gridResult = await dataSource.call({
            gridState: {
                filters,
                facetFilters: [],
                sorting: this.state.sorting,
                paging: {
                    pageIndex: pageIndex,
                    pageSize: this.props.pageSize
                }
            }
        });

        this.setState({
            isLoading: false,
            ...gridResult
        });
    }

    getSortClass({fieldName}) {
        const {sorting} = this.state;

        if (sorting && sorting.fieldName === fieldName)
            return `sorting-${sorting.direction}`;

        return '';
    }

    async toggleSort({fieldName}) {
        let {sorting} = this.state;

        sorting = sorting && sorting.fieldName === fieldName && sorting.direction === 'asc'
            ? {fieldName, direction: 'desc'}
            : {fieldName, direction: 'asc'};

        this.setState({
            sorting
        }, () => this.fetchGridData(0));
    }

    async updateFilters(fieldName, filter) {
        this.setState({
            filters: {
                ...this.state.filters,
                [fieldName]: filter
            }
        }, () => this.fetchGridData(0));
    }

    resetFilters() {
        if (!this.props.allowReset)
            return;

        this.setState({
            filters: {},
            facetFilters: {}
        }, () => this.fetchGridData(0));
    }

    async reloadGridData() {
        if (!this.props.allowReload)
            return;

        await this.fetchGridData();
    }

    async exportToXlsx() {
        if (!this.props.allowXlsxExport)
            return;

        const {gridId} = this.props;

        let getFileToken = new BackEnd.Tokens.GetFileToken();
        let token = await getFileToken.call();

        let exportToXlsx = new BackEnd.Grids.ExportToXlsx();
        let href = exportToXlsx.createUrl({gridId, token});

        console.log(href);

        $('<a />').attr({href, download: 'download'}).get(0).click();
    }
}

export default DataGrid;


// WEBPACK FOOTER //
// ./src/datagrid/DataGrid.js